import { createFileRoute } from '@tanstack/react-router';
import { ConnectorManager } from '../../components/admin/ConnectorManager';

export const Route = createFileRoute('/admin/connectors')({
  component: ConnectorsTab,
});

function ConnectorsTab() {
  return <ConnectorManager />;
}
